var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "discuss_wrap"
    },
    [
      _c("div", {
        staticClass: "menu-toggle",
        class: { "menu-open": !_vm.menuFlag },
        on: { click: _vm.toggleMenu }
      }),
      _vm._v(" "),
      _vm.menuFlag
        ? _c("div", { staticClass: "discuss_left" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "router-link",
                  {
                    key: index,
                    attrs: {
                      tag: "li",
                      to: {
                        path: item.path,
                        query: {
                          id: _vm.$route.query.id,
                          classId: _vm.$route.query.classId,
                          className: _vm.$route.query.className
                        }
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.reload()
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      { staticClass: "list-group-item list-group-item-action" },
                      [
                        _c("i", {
                          class: item.class,
                          style:
                            "background:url(" +
                            item.src +
                            ") no-repeat;background-size:100%"
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(item.name))])
                      ]
                    )
                  ]
                )
              }),
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "discuss_right" }, [_c("router-view")], 1)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c6f1650", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c6f1650","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/discuss/discuss.vue
// module id = null
// module chunks = 